import { useIntl } from 'react-intl';
import { Label } from 'ui/Label';
import { ListingApplication } from '../../../../../types/ListingData';

interface ProducerCommentsProps {
  producerComment?: string | null;
  applicationData?: ListingApplication | null;
}

export const ProducerComments = ({
  producerComment,
  applicationData,
}: ProducerCommentsProps) => {
  const intl = useIntl();

  return (
    <div className="summary-section producer-comments">
      <Label
        label={intl.formatMessage({
          id: 'listings.application.producer_comments',
        })}
        title={true}
      />
      <p>
        {producerComment ||
          applicationData?.producer_comment ||
          intl.formatMessage({ id: 'listings.application.no_comments' })}
      </p>
    </div>
  );
};
